import { ITranslations } from 'types/common';
import { AppLoaderTransFields } from './types';
import en from 'translations/en/appLoader.json';
import pl from 'translations/pl/appLoader.json';
import sl from 'translations/sl/appLoader.json';

export const appLoaderTranslations: ITranslations<AppLoaderTransFields> = {
  name: 'appLoader',
  en,
  pl,
  sl,
};
